<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات دسته بندی بیماری"
        >
          <b-form
              ref="sicknesscategoryform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="6"
                  offset-md="3"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"

                            size="90px"
                            rounded
                        />
                      </template>
                      <div class="d-flex flex-wrap align-self-end">
                        <b-button
                            variant="outline-info"
                            @click="$refs.refInputEl.click()"
                        >
                          <input
                              ref="refInputEl"
                              type="file"
                              class="d-none"
                              name="Image"
                              @input="imageRenderer"
                          >
                          <span class="d-none d-sm-inline">انتخاب عکس</span>
                          <feather-icon
                              icon="EditIcon"
                              class="d-inline d-sm-none"
                          />
                        </b-button>
                      </div>
                    </b-media>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="عنوان"
                        label-for="Title"
                    >
                      <b-form-input
                          id="Title"
                          v-model="Form.Title"
                          name="Title"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-input
                            id="Description"
                            v-model="Form.Description"
                            name="Description"
                            autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'SicknessCategoryDetails',
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.sicknesscategory.add
      if (this.$route.params.id) {
        url = this.$api.sicknesscategory.update
      }

      const formData = new FormData(this.$refs.sicknesscategoryform)
      formData.append('Id', this.Form.Id)

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.sicknesscategory.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
          })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
